import React from 'react';
import ReactDOM from 'react-dom/client';
import 'antd/dist/reset.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import './theme-colors.css';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { installDemoApi } from './demo/demoApi';
import { initColorMode } from './lib/colorMode';

ModuleRegistry.registerModules([AllCommunityModule]);

// 다크모드 클래스를 첫 화면 전에 붙인다
initColorMode();

// 데모 모드일 때만 동작하는 API 인터셉터. 평소에는 원래 fetch 를 그대로 통과시킨다.
installDemoApi();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
